module.exports = __webpack_public_path__ + "static/media/Wed1.5f1f2f67.jpg";